import { Vector2i } from "js-vextensions";
export class MapUIStore {
    constructor() {
        this.zoomLevel = 1;
        this.viewCenter = new Vector2i(0, 0);
        this.scrollSpeed_keys = 700;
        this.zoomSpeed_keys = 15;
    }
}
/*export class ACTZoomMap extends Action<{zoomMultiplier: number}> {}
export class ACTScrollMap extends Action<{scrollTo?: Vector2i, scrollChange?: Vector2i}> {}

export const MapUIReducer = CombineReducers({
    zoomLevel: (state = 1, action)=>{
        if (action.Is(ACTZoomMap)) return state * action.payload.zoomMultiplier;
        return state;
    },
    viewCenter: (state: Vector2i = new Vector2i(0, 0), action)=>{
        if (action.Is(ACTScrollMap)) return action.payload.scrollTo || state.As(Vector2i).Plus(action.payload.scrollChange);
        return state;
    },
    scrollSpeed_keys: SimpleReducer(a=>a.main.write.map.scrollSpeed_keys, 700),
    zoomSpeed_keys: SimpleReducer(a=>a.main.write.map.zoomSpeed_keys, 15),
});*/ 
